import { render, staticRenderFns } from "./OnboardReport.vue?vue&type=template&id=47cea88b&scoped=true"
import script from "./OnboardReport.vue?vue&type=script&lang=ts"
export * from "./OnboardReport.vue?vue&type=script&lang=ts"
import style0 from "./OnboardReport.vue?vue&type=style&index=0&id=47cea88b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cea88b",
  null
  
)

export default component.exports